export function BlankLayout() {
  let $layoutContentContainer: HTMLElement | null = null;

  function init() {
    $layoutContentContainer = document.querySelector("#layout-content");
  }

  function populate(content: string) {
    if ($layoutContentContainer)
      $layoutContentContainer.innerHTML = content;
    else
      console.error("App layout content container not found!");
  }

  function render() {
    return /*html*/`
      <div id="layout-content"></div>
    `;
  }

  return { init, render, populate };
}